module.exports = __webpack_public_path__ + "img/information_b.a2ca37bd.svg";